import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "../lib/supabase";
import { roleLabel } from "./labels";
import s from "./Reviewer.module.css";

interface VagaAgg { role: string; testes: number; candidatos: number; corrigidos: number; }

export function VagasList() {
  const nav = useNavigate();
  const [vagas, setVagas] = useState<VagaAgg[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const [{ data: assessments }, { data: pipe }] = await Promise.all([
        supabase.from("rec_assessments").select("id, role"),
        supabase.from("rec_v_pipeline").select("assessment_role, status, score_status"),
      ]);
      const byRole: Record<string, VagaAgg> = {};
      for (const a of assessments || []) {
        byRole[a.role] = byRole[a.role] || { role: a.role, testes: 0, candidatos: 0, corrigidos: 0 };
        byRole[a.role].testes++;
      }
      for (const p of pipe || []) {
        const r = byRole[p.assessment_role]; if (!r) continue;
        r.candidatos++;
        if (p.status === "graded" || p.status === "reviewed") r.corrigidos++;
      }
      setVagas(Object.values(byRole).sort((a, b) => roleLabel(a.role).localeCompare(roleLabel(b.role))));
      setLoading(false);
    })();
  }, []);

  return (
    <div className={s.page}>
      <div className={s.h}><h2>Vagas</h2></div>
      <p className="muted" style={{ marginTop: -8 }}>Escolha uma vaga para ver os testes e os candidatos.</p>
      {loading ? <p className="muted">Carregando…</p> : vagas.length === 0 ? <div className={s.empty}>Nenhuma vaga ainda.</div> : (
        <div className={s.cards}>
          {vagas.map((v) => (
            <div key={v.role} className={s.vcard} onClick={() => nav(`/admin/vaga/${v.role}`)} role="button" tabIndex={0}>
              <div className={s.pill}>vaga</div>
              <h3 style={{ marginTop: 8 }}>{roleLabel(v.role)}</h3>
              <div className={s.vstats}>
                <div><b>{v.testes}</b><span>{v.testes === 1 ? "teste" : "testes"}</span></div>
                <div><b>{v.candidatos}</b><span>candidatos</span></div>
                <div><b>{v.corrigidos}</b><span>corrigidos</span></div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
